import { render, staticRenderFns } from "./HotArea.vue?vue&type=template&id=45c6a76f&scoped=true"
import script from "./HotArea.vue?vue&type=script&lang=js"
export * from "./HotArea.vue?vue&type=script&lang=js"
import style0 from "./HotArea.vue?vue&type=style&index=0&id=45c6a76f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c6a76f",
  null
  
)

export default component.exports